// This file is automatically generated. Do not edit it directly.
import { createClient } from './createClient';
import type { Database } from './types';

const SUPABASE_URL = "https://rlquvkzgnvmfeylcchwl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJscXV2a3pnbnZtZmV5bGNjaHdsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzODA1NDUsImV4cCI6MjA3NTk1NjU0NX0._11yZV5ZRioCenYy75GODIa6UL1fW1jn3G8ClOgMhgk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const storage = typeof window !== 'undefined' ? window.localStorage : undefined;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage,
    persistSession: true,
    autoRefreshToken: true,
  }
});